<template>
  <div class="com-player">
    <div class="title">对局详情</div>
    <div class="list">
      <PlayerList
        v-for="(team, index) in teamList"
        :key="index"
        :teamInfo="team"
        :type="index == 0 ? 'green' : 'red'"
      />
    </div>
  </div>
</template>

<script>
import PlayerList from './player-list.vue';
export default {
  components: {
    PlayerList,
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => ({}),
    },
    matchData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    teamList() {
      return this.dataInfo.player.team_list || [];
    },
  },
};
</script>

<style lang="less" scoped>
.com-player {
  padding: 10px 0;
  background: #fafbfc;
  .title {
    padding: 0 10px;
    font-size: 12px;
    color: rgba(20, 25, 30, 1);
    line-height: 24px;
    font-weight: 500;
  }
}
</style>
